import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, FormBuilder, Validators, ControlValueAccessor, FormControl } from '@angular/forms';

import { Subscription } from 'rxjs';
import { NameFormValues, PasswordFormValues } from 'src/app/model';
import { SubmitButtonClickService } from 'src/app/services';

@Component({
  selector: 'app-password-form',
  templateUrl: './password-form.component.html',
  styleUrls: ['./password-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PasswordFormComponent),
      multi: true
    }
  ]
})
export class PasswordFormComponent implements ControlValueAccessor, OnDestroy {

  hide = true;
  confirmHide = true;
  form: FormGroup;
  submitted: boolean = false;

  private _subscriptions: Subscription[] = [];
  private _valueChangesSubscription: Subscription;
  private _getSubmitButtonClickSubscription: Subscription;
  private _getSubmitButtonSuccessSubscription: Subscription;

  constructor(
    private _fb: FormBuilder,
    private _submitButtonClick: SubmitButtonClickService,
    private _submitButtonSuccess: SubmitButtonClickService

  ) {
    this.form = this._fb.group({
      password: ['', [Validators.required, Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$")]],
      confirmPassword: ['', [Validators.required]]
    },
      { validator: this._matchingInputsValidator('password', 'confirmPassword') });

    this._subscriptions.push(
      // any time the inner form changes update the parent of any change
      this._valueChangesSubscription = this.form.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
    this._getSubmitButtonClickSubscription = this._submitButtonClick.getSubmitButtonClick().subscribe((res: any) => {
      this.submitted = true;
    });
    this._getSubmitButtonSuccessSubscription = this._submitButtonSuccess.getSubmitButtonSuccess().subscribe((res: any) => {
      this.submitted = false;
    })
  }

  get value(): PasswordFormValues {
    return this.form.value;
  }

  set value(value: PasswordFormValues) {
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
    this._valueChangesSubscription?.unsubscribe();
    this._getSubmitButtonClickSubscription?.unsubscribe();
    this._getSubmitButtonSuccessSubscription?.unsubscribe();

  }

  get passwordControl() {
    return this.form.controls;
  }


  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: NameFormValues | null) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.form.reset();
    }
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: FormControl) {
    return this.form.valid ? null : { name: { valid: false } };
  }
  _errorMsg: any = { isErrorMsg: false, errorMessage: '' };
  private _matchingInputsValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors['mustMatch']) {

        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
      return;
    };
  }

}
